import script from "./Desc.vue?vue&type=script&setup=true&lang=js"
export * from "./Desc.vue?vue&type=script&setup=true&lang=js"

import "./Desc.vue?vue&type=style&index=0&id=5bd471f2&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd471f2"]])

export default __exports__